import { render, staticRenderFns } from "./edit-table.vue?vue&type=template&id=2696d831&"
import script from "./edit-table.vue?vue&type=script&lang=js&"
export * from "./edit-table.vue?vue&type=script&lang=js&"
import style0 from "./edit-table.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports